Vue.component('panel-plugin', {
	props: ['options','labellang'],
	template:	'<transition v-if="isActive" name="bounce" enter-active-class="bounceInUp" leave-active-class="bounceOutRight" v-bind:css="options.internal.isAnimationCompatibility">' +
	'<div id="panel-plugin">'+
		'<div class="row" v-show="nextStep">'+
			'<h3 class="text-center">{{ this.optionPanel.install_for_screensharing }}</h3>' +
			'<button class="btn btn-primary btn-block text-center" @click.once="callDownload">{{  this.optionPanel.installnow  }}</button>'+
			'<div class="bt-group-skip">'+
			'<button class="btn btn-link text-center col-xs-3 col-xs-offset-9"  @click="closePanel">{{ this.optionPanel.nothanks }}</button>'+
			'</div>'+
		'</div>'+
		'<div class="row text-center" v-show="!nextStep">'+
			'<h3 class="text-center">{{ this.optionPanel.waiting }}</h3>' +
			'<div class="text-center loader-custom"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div>'+
			'<div class="bt-group-skip">'+
			'<div class="row">'+
			'<button class="btn btn-link text-center col-xs-3 col-xs-offset-3" @click="closePanel">{{  this.optionPanel.cancel  }}</button>'+
			'<button class="btn btn-link  text-center col-xs-3" @click.once="reDownload">{{  this.optionPanel.download  }}</button>'+
			'</div>'+
			'</div>'+
		'</div>'+
	'</transition>',
	data: function(){
		return {
			isActive:false,
			isAllowClose:false,
			optionPanel:null,
			nextStep:true,
			iconLoader:'../img/loader.svg',
		}
	},
	mounted: function() {
		var that = this;

		this.$parent.$on('onPanelPlugin', function (val) {
			 setTimeout(function(){ 	that.contentShow(val); }, 800);

		})

		this.$parent.$on('onPanelOption', function (options) {
			that.defineOptionPanel(options);
		})


	},
	methods:{
		contentShow:function(val){
			this.isActive = val;
		},
		closePanel:function(){
			this.contentShow(false);
			bus.$emit('onPanelPluginClose', false);

		},
		defineOptionPanel:function(options){
			this.optionPanel = options;
		},
		callDownload:function(){
				window.open(this.optionPanel.url ,'_blank');
				this.nextStep = false;
				bus.$emit('onPanelPluginClose', false);

		},
		reDownload:function(){
			window.open(this.optionPanel.url ,'_blank');
			bus.$emit('onPanelPluginClose', false);

		}
	}
})
